import template from './swag-cms-extensions-custom-form-element-number.html.twig';

export default {
    template,
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
    computed: {
        value() {
            const placeholder = this.field.translated ? this.field.translated.placeholder : this.field.placeholder;
            return Number(placeholder);
        },
    },
}
